import React from 'react'

import { UA } from '@js/common/UA'

export interface FavoriteHouse {
  isFavorite: boolean
  addToFavorites: () => void
  removeFromFavorites: () => void
}

export function useFavorite(nid: string): FavoriteHouse {
  const [isFavorite, setIsFavorite] = React.useState(UA.isFavourite(nid))

  const addToFavorites = () => {
    setIsFavorite(true)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    UA.addFavourite(nid).catch(() => {
      setIsFavorite(false)
    })
  }

  const removeFromFavorites = () => {
    setIsFavorite(false)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    UA.removeFavourite(nid).catch(() => {
      setIsFavorite(true)
    })
  }

  return {
    isFavorite,
    addToFavorites,
    removeFromFavorites
  }
}
